import React, { Suspense } from 'react';

import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import './i18n';

import LoadingIcon from './frontend/items/buttons/LoadingIcon';

//Bootstrap CSS (only for grid and utility classes, no JS components)
import 'bootstrap/dist/css/bootstrap.min.css';

//flagcss
import 'flag-icon-css/css/flag-icon.min.css';

const root = createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={<LoadingIcon />}>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  </Suspense>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
